import { render, staticRenderFns } from "./modalViewTermsAndConditions.vue?vue&type=template&id=46b59892&"
import script from "./modalViewTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./modalViewTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports